import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/material-dashboard-react.css?v=1.5.0";
import App from "./App";
import Amplify, { Auth } from "aws-amplify";
import config from "./aws-exports";

//redux setup

import { createStore, applyMiddleware, compose } from "redux";
import reducer from "./redux/reducers";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import { connect } from "react-redux";

import * as actionTypes from "./redux/actions";
const logger = store => {
  return next => {
    return action => {
      const result = next(action);
      return result;
    };
  };
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducer,
  composeEnhancers(
    applyMiddleware(
      logger,
      // require('redux-immutable-state-invariant').default(),
      thunk
    )
  )
);

//redux Ends

Amplify.configure(config);

Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: "us-east-2:6d654a41-2d06-45ac-92a5-60c3fe635377",

    mandatorySignID: true,
    // REQUIRED - Amazon Cognito Region
    region: "us-east-2",
    // OPTIONAL - Amazon Cognito User Pool ID
    //userPoolId: "us-east-2_EZT5XPRKI",//default
    //userPoolId: "us-east-2_MjL8f7JY6", //calbit
    //userPoolId: "us-east-2_uvv0YFOFE", //calbit2
    userPoolId: config.aws_user_pools_id, //calbitpool

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    //userPoolWebClientId: "4bi0u7va0oo9vg9eovih5s9dp4"//default
    //userPoolWebClientId: "4vg47998u17bghi2oq4h150srq" //calbit
    //userPoolWebClientId: "1nm75a8usu2omnct1v19j22d97" //calbit2
    userPoolWebClientId: config.aws_user_pools_web_client_id //calbitpool
  },
  aws_appsync_graphqlEndpoint:
    "https://re5ooud3xzczlamoi5fdiignje.appsync-api.us-east-2.amazonaws.com/graphql",
  aws_appsync_region: "us-east-2",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "kvj46dweffcgzd53hcfivt4rm4"
});

// You can get the current config object
const currentConfig = Auth.configure();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js